export enum EPasswordTypes {
  PASSWORD = 'password',
  TEXT = 'text',
}
